import StarterKit from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extension-placeholder';
import { CustomImage } from './custom-image-extension';
import { Link as TiptapLink } from '@tiptap/extension-link';
import { Underline } from '@tiptap/extension-underline';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import { Highlight } from '@tiptap/extension-highlight';
import { TaskItem } from '@tiptap/extension-task-item';
import { TaskList } from '@tiptap/extension-task-list';

export const defaultExtensions = [
  StarterKit.configure({
    bulletList: {
      HTMLAttributes: {
        class: 'list-disc list-outside ml-4 my-4',
      },
    },
    orderedList: {
      HTMLAttributes: {
        class: 'list-decimal list-outside ml-4 my-4',
      },
    },
    listItem: {
      HTMLAttributes: {
        class: 'my-2',
      },
    },
    blockquote: {
      HTMLAttributes: {
        class: 'border-l-4 border-primary pl-6 italic my-6 text-muted-foreground',
      },
    },
    codeBlock: {
      HTMLAttributes: {
        class: 'rounded bg-muted text-foreground p-4 font-mono text-sm my-4 border border-border',
      },
    },
    code: {
      HTMLAttributes: {
        class: 'rounded bg-muted text-foreground px-1.5 py-0.5 font-mono text-sm',
        spellcheck: 'false',
      },
    },
    horizontalRule: {
      HTMLAttributes: {
        class: 'my-8 border-border',
      },
    },
    heading: {
      levels: [1, 2, 3],
      HTMLAttributes: {
        class: 'font-serif font-bold text-foreground',
      },
    },
    dropcursor: {
      color: 'hsl(var(--primary))',
      width: 2,
    },
    gapcursor: false,
  }),
  Placeholder.configure({
    placeholder: 'Tell your story...',
    showOnlyWhenEditable: true,
  }),
  TiptapLink.configure({
    HTMLAttributes: {
      class: 'text-primary underline underline-offset-2 hover:text-primary/80 transition-colors cursor-pointer',
    },
    openOnClick: false,
  }),
  CustomImage.configure({
    allowBase64: false,
    inline: false,
  }),
  Underline,
  TextStyle,
  Color,
  Highlight.configure({
    multicolor: true,
  }),
  TaskList.configure({
    HTMLAttributes: {
      class: 'not-prose pl-2 my-4',
    },
  }),
  TaskItem.configure({
    HTMLAttributes: {
      class: 'flex items-start my-2',
    },
    nested: true,
  }),
];
